import React, {Component} from 'react';
import {Card, CardHeader, Row, Col, CardBody, Input} from 'reactstrap';
import {Dropdown, Button as SementicBtn, Button, Checkbox} from "semantic-ui-react";
import apiConfig from "../../../axios/axios_api_services";
import axios_eventtag from "../../../axios/axios_eventtag";
import * as common from "../../../const/Common/CommonFunc";
import Cookies from "js-cookie";
import {connect} from "react-redux";
import * as actionCreator from "../../../store/Action";
import {MDBDataTable} from "mdbreact";
import './Style.scss';
import Download from "../../../components/Button/DownloadbleButton";
import * as timeUtils from '../../../util/TimeConvertor';
import ViewAnswers from "../../Event/ManageEvent/AddViewModify/Participants/ViewAnswers/ViewAnswers";

class checkedParticipant extends Component {
  state = {
    event_list: [],
    eventSubEvents: [],
    checkedParticipants: [],
    downloadList: [],
    subEventId: '',
    eventId: '',
    cop_id: '',
    searchBtnVisible: false,
    isViewAnswers: false,
    answers: []
  };
  getEvents = (status) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let corperateId = this.props.usr_obj.corporates[0].corporateId;
    axios_eventtag.get(apiConfig.CORPORATE_EVENTS({corporateId: corperateId}), {headers: headers})
      .then(async response => {
        this.props.spinnerHandler(false);

        if (response.data.success) {
          this.setState({
            event_list: response.data.eventList,
            cop_id: corperateId
          });
          if (status === "ON_LOAD") {
            let firstEventId = response.data.eventList.length !== 0 ? response.data.eventList[0].event_id : '';
            this.setState({
              eventId: firstEventId
            });
            this.getSubEvents(firstEventId, "ON_LOAD")
          }
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getEvents(status);
        } else {
          this.props.spinnerHandler(false)
        }
      })
      .finally(fin => {
      });
  };
  onChangeEventHandler = (e, {value}) => {
    this.setState({
      eventId: value, subEventId: '', checkedParticipants: [], downloadList: [], searchBtnVisible: false
    });
    this.getSubEvents(value);
  };
  getSubEvents = (id, status) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let eventid = id;

    let corperateId = this.state.cop_id;
    axios_eventtag.get(apiConfig.GET_SUBEVENT({event_id: eventid, corporateId:corperateId}), {headers: headers})
      .then(response => {
        this.props.spinnerHandler(false);
        if (response.data.success) {

          this.setState({
            eventSubEvents: response.data.subEventList
          });

          if (status === "ON_LOAD") {
            let firstSubeventId = response.data.subEventList.length !== 0 ? response.data.subEventList[0].sub_event_id : '';
            this.setState({
              subEventId: firstSubeventId
            });
            this.getCheckedParticipants(firstSubeventId);
          }

        } else {
          this.setState({
            eventSubEvents: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getSubEvents(id, status);
        } else {
          this.props.spinnerHandler(false);
        }
      })
      .finally(fin => {
      });
  };
  onChangeSubeEventHandler = (e, {value}) => {
    this.setState({
      subEventId: value,
      searchBtnVisible: true
    });
    this.getCheckedParticipants(value);
  };
  getCheckedParticipants = (value) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let {cop_id} = this.state;
    axios_eventtag.get(apiConfig.GET_CHECKED_PARTICIPANTS({sub_event_id: value, corporateId:cop_id}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          let downloadList = [];
          let participantList = response.data.participantList;
          if(participantList.length > 0) {
            participantList.map((obj,i) => {
              let downloadObj = {participant_id: obj.participant_id, first_name: obj.first_name, last_name: obj.last_name, email: obj.email, mobile: obj.mobile, checkInTime: obj.checkInTime ? timeUtils.convertDateObjStringToHumenReadable(obj.checkInTime) : ''};
              if(obj.answers.length > 0) {
                obj.answers.map((ansObj,insIndex) => {
                  downloadObj[`question_${insIndex + 1}`] = ansObj.answerDTO ? ansObj.answerDTO.answer : ansObj.answer
                })
              }
              downloadList.push(downloadObj)
            })
          }
          this.setState({checkedParticipants: participantList, downloadList})
        } else {
          this.setState({checkedParticipants: [], downloadList: []})
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) this.getCheckedParticipants(value);
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  componentDidMount() {
    this.getEvents("ON_LOAD_");
  }

  updateAnswerArray = (value) => {
    // this.setState({
    //   answers: value,
    //   isViewAnswers: true
    // })
    this.props.eventModalDataAction(value)
    this.props.eventModalAction(true);
  }

  componentWillUnmount() {
    this.props.eventModalDataAction([])
    this.props.eventModalAction(false);
  }

  render() {
    let {downloadList} = this.state;
    let EventList = [];

    if (this.state.event_list.length !== 0) {
      this.state.event_list.map((value, index) => {
        EventList.push({
          text: value.event_name,
          value: value.event_id,
          key: value.event_id
        })
      })
    }

    let subEventList = [];
    if (this.state.eventSubEvents.length !== 0) {
      this.state.eventSubEvents.map((value, index) => {
        subEventList.push({
          text: value.name,
          value: value.sub_event_id,
          key: value.sub_event_id
        });
      });
    }

    let tblColumns = this.props.checked_table_data.columns;
    let tblRows = [];

    if (this.state.checkedParticipants !== null) {
      this.state.checkedParticipants.map((value, index) => {
        tblRows.push({
          FirstName: value.first_name,
          LastName: value.last_name,
          Phone: value.mobile,
          Email: value.email,
          checkedInTime: value.checkInTime !== null ? timeUtils.convertDateObjStringToHumenReadable(value.checkInTime) : '',
          action: value.answers.length > 0 && <div>
            <button className={'cmn-view-btn mr-1'} onClick={() => this.updateAnswerArray(value.answers)}>View Answers</button>
          </div>
        })
      })
    }

    return (
      <div className="event-org-dashboard">
        <Row>
          <ViewAnswers />
          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            {
              this.props.usr_obj.userRoles === "CORP_EVENT_ORGANIZER" ?
                <h4 className={"route-name-style"}>{this.props.route_name}</h4>
                : <h4 className={"route-none-style"}/>
            }
            <Card className="card1">
              <CardHeader>
                Filter Events
              </CardHeader>
              <Col lg={12}>
                <Row className={"search-event-row"}>
                  <Col lg={4} md={"12"} sm={"12"} xs={"12"}>
                    <Dropdown
                      placeholder='Select Event'
                      fluid
                      // className="dropdown"
                      search
                      selection
                      value={this.state.eventId}
                      options={EventList}
                      onChange={this.onChangeEventHandler}
                    />
                  </Col>
                  <Col lg={4} md={"12"} sm={"12"} xs={"12"}>
                    <Dropdown
                      placeholder='Select Sub Event'
                      fluid
                      // className="dropdown"
                      search
                      selection
                      value={this.state.subEventId}
                      options={subEventList}
                      onChange={this.onChangeSubeEventHandler}/>
                  </Col>
                  {this.state.searchBtnVisible &&
                    <Col lg={"1.5"} md={"1.5"} sm={"1.5"} xs={"1.5"}
                        className={"d-flex align-items-center justify-content-center"}>
                        <SementicBtn className="ui inverted primary button"
                                 onClick={() => this.getCheckedParticipants(this.state.subEventId)}>Search</SementicBtn>
                  </Col>}
                </Row>
              </Col>
            </Card>
            <Card>
              <CardHeader>
                Participants
                <Download data={downloadList} filename={"checked-in-participants.csv"}/>
              </CardHeader>
              <CardBody>
                {/* {this.state.subEventParticipant.length !== 0 ? */}
                <MDBDataTable
                  striped
                  searching={true}
                  displayEntries={true}
                  paging={true}
                  entries={8}
                  responsive
                  responsiveSm
                  responsiveMd
                  responsiveLg
                  responsiveXl
                  bordered
                  hover
                  data={{rows: tblRows,columns: tblColumns}}
                />
                {/* //   <div className={"align-center fully-width"}>
                //     <Empty description={"No Participants"} className={"empty-icon"}/>
                //   </div>} */}

              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  test_alleventobject: state.eventReducer.allEventsObj,
  usr_obj: state.userReducer.user,
  checked_table_data: state.participantReducer.Checked_Participant_Table_data,
  // modalVisible: state.eventModalReducer.modalVisible,
  // answers: state.eventModalReducer.modalData
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // event modals
    eventModalAction: (data) => dispatch(actionCreator.eventModalAction(data)),
    eventModalDataAction: (data) => dispatch(actionCreator.eventModalDataAction(data)),
    // all available cards
    receptionAllAvailableCardHandler: (data) => dispatch(actionCreator.receptionAllAvailableCardHandler(data)),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(checkedParticipant);
